import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import axios from 'axios';
import { MessageBox, Message } from 'element-ui';
import store from '@/store';
import { getToken, removeToken } from '@/utils/auth';
import { resetRouter } from '@/router';
import qs from 'qs';
import router from '@/router';
var hasCancelled = false;
// create an axios instance
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  transformRequest: [function (data) {
    if (data instanceof FormData) {
      return data;
    }
    data = qs.stringify(data);
    return data;
  }],
  timeout: 10000 // request timeout
});
service.interceptors.request.use(function (config) {
  hasCancelled = false;
  if (!config.hideLoading) {
    store.commit('settings/SET_LOADING', true);
  }
  // if (config.method === 'post') {
  //   config.data = qs.stringify(config.data)
  // }
  console.log(store.getters.token);
  if (getToken()) {
    config.headers['Authorization'] = 'Bearer ' + getToken();
    // 在发送请求设置cancel token
    config.cancelToken = new axios.CancelToken(function (cancel) {
      store.commit('settings/PUSH_CANCEL', {
        cancelToken: cancel
      });
    });
  }
  return config;
}, function (error) {
  console.log(error); // for debug
  store.commit('settings/SET_LOADING', false);
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  store.commit('settings/SET_LOADING', false);
  var res = response.data;
  // if the custom code is not 20000, it is judged as an error.
  if (res.status !== 200) {
    if (!hasCancelled) {
      hasCancelled = true;
      Message({
        // message: res.message || 'Error',
        dangerouslyUseHTMLString: true,
        message: res.message ? "<div style='word-break:break-all;'>".concat(res.message, "</div>") : 'Error',
        type: 'error',
        // 个别接口可通过请求参数 errorDuration 自定义错误提示停留时长，默认 5 秒
        duration: response.config.errorDuration || 5 * 1000
      });
      // 礼包列表价格计算超过预算提示
      if (res.status === 402) {
        return res;
      }
      // 登录失效处理
      if (res.status === 401) {
        removeToken();
        resetRouter();
        store.commit('user/RESET_STATE');
        store.state.permission.routes = [];
        router.replace('/login');
        // location.href = process.env.web_url + '/#/login'
      }
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      // if (res.status === 401) {
      //   // to re-login
      //   MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
      //     confirmButtonText: 'Re-Login',
      //     cancelButtonText: 'Cancel',
      //     type: 'warning'
      //   }).then(() => {
      //     store.dispatch('user/resetToken').then(() => {
      //       location.reload()
      //     })
      //   })
      // }
      return Promise.reject(new Error(res.message || 'Error'));
    }
  } else {
    return res;
  }
}, function (error) {
  console.log('err' + error); // for debug
  store.commit('settings/SET_LOADING', false);
  if (error.message === '取消请求') {
    return Promise.reject(error);
  }
  if (error.message.includes('timeout')) {
    Message({
      message: '您的请求超时，请稍后再试',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
  Message({
    message: '您的网络连接出现错误，请稍后再试',
    type: 'error',
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
export default service;